<template>
  <TokenManagement />
</template>

<script lang="ts">
import { defineComponent, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import TokenManagement from '@/components/content/TokenManagement.vue'

export default defineComponent({
  name: 'TokenManagementView',
  components: { TokenManagement },
  emits: ['pageName'],
  setup(props, context) {
    const i18n = useI18n()

    context.emit('pageName', i18n.t('aside.menu.pages.tokenManagement'))

    watch(() => i18n.locale.value, () => {
      context.emit('pageName', i18n.t('aside.menu.pages.tokenManagement'))
    })
  }
})
</script>
